export class PreOrderDto {
  requestId: string;
  flights: string[];
  travelers: any[];
  userUuid?: string;
}
